export default __webpack_public_path__ + "static/media/404-bidoof.cbb38d15.png";